"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutAnchoredObjectBoxComparer = exports.getLayoutAnchoredObjectBoxInitialComparer = exports.posAndAncInfoOneSubDocComparer = void 0;
var layout_anchored_object_box_1 = require("../../../layout/main-structures/layout-boxes/layout-anchored-object-box");
function posAndAncInfoOneSubDocComparer(a, b) {
    var aAncInfo = a.anchorInfo;
    var bAncInfo = b.anchorInfo;
    switch (aAncInfo.levelType) {
        case layout_anchored_object_box_1.AnchoredObjectLevelType.BehindText:
            if (bAncInfo.levelType != layout_anchored_object_box_1.AnchoredObjectLevelType.BehindText)
                return -1;
            break;
        case layout_anchored_object_box_1.AnchoredObjectLevelType.BeforeText:
        case layout_anchored_object_box_1.AnchoredObjectLevelType.InText:
            if (bAncInfo.levelType == layout_anchored_object_box_1.AnchoredObjectLevelType.BehindText)
                return 1;
            break;
    }
    var cmpZOrder = aAncInfo.zOrder - bAncInfo.zOrder;
    return cmpZOrder ? cmpZOrder : b.position - a.position;
}
exports.posAndAncInfoOneSubDocComparer = posAndAncInfoOneSubDocComparer;
function getLayoutAnchoredObjectBoxInitialComparer(anchorObjectsPositionInfo) {
    var getPos = function (obj) { return anchorObjectsPositionInfo.getPosition(obj.objectId); };
    return function (a, b) {
        var zOrderDiff = a.anchorInfo.zOrder - b.anchorInfo.zOrder;
        return zOrderDiff ? zOrderDiff : getPos(a) - getPos(b);
    };
}
exports.getLayoutAnchoredObjectBoxInitialComparer = getLayoutAnchoredObjectBoxInitialComparer;
function getLayoutAnchoredObjectBoxComparer(anchorObjectsPositionInfo) {
    var getPos = function (obj) { return anchorObjectsPositionInfo.getPosition(obj.objectId); };
    return function (a, b) {
        var cmpLevel = a.rendererLevel - b.rendererLevel;
        return cmpLevel ? cmpLevel : (a.anchorInfo.zOrder != b.anchorInfo.zOrder ? a.anchorInfo.zOrder - b.anchorInfo.zOrder : getPos(a) - getPos(b));
    };
}
exports.getLayoutAnchoredObjectBoxComparer = getLayoutAnchoredObjectBoxComparer;
